query currentUserWithTeachers($tz: String!) {
  currentUser {
    id
    first
    teams {
      id
    }
    teachers {
      id
      insertedAt(tz: $tz)
      team {
        id
        name
      }
    }
  }
}
